import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../../../global/commonStyle';
interface Props {
  display?: boolean;
  isHover?: boolean;
  isEmptyLogo?: boolean;
}

const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;

const Desc = styled.p`
  margin: var(--space-0);
  ${Typography.body_md}
  color: var(--text-primary);
`;
const Card = styled.div`
  display: flex;
  gap: var(--space-20);
  align-items: flex-start;
  flex-wrap: wrap;
  ${mobile_xl(css`
    flex-direction: column;
  `)}
`;

const Section = styled.div`
  ${mobile_xl(css`
    display: flex;
    flex-direction: column;
    gap: var(--space-12);
  `)}
`;

const BrandTitleSection = styled.div`
  ${AlignCenter}
  gap: var(--space-20);
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;

const ResponsiveBrandTitle = styled.p`
  margin: var(--space-0);
  ${Typography.heading_md};
  color: var(--text-primary);
`;

const Square = styled.div`
  ${AlignCenter};
  flex-direction: column;
  gap: var(--space-6);
  p {
    margin: var(--space-0);
    ${Typography.body_lg_medium};
    color: var(--text-primary);
  }
`;
const Logo = styled.div<Props>`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  ${FlexCenter}
  cursor: pointer;
  position: relative;
  &.logo-empty {
    ${AlignCenter}
    gap: var(--space-10);
  }
  h4 {
    margin: var(--space-0);
    ${Typography.heading_md}
    color: var(--text-placeholder);
  }

  .favicon-logo {
    border-radius: var(--border-radius-4);
  }
  &.logo-img {
    max-width: 300px;
    width: auto;
    padding: var(--space-7);
    height: max-content;
    .logo {
      height: 64px;
      border-radius: var(--border-radius-4);
      object-fit: contain;
    }
    &.logo-empty {
      ${AlignCenter}
      gap: var(--space-10);
    }
    h4 {
      margin: var(--space-0);
      ${Typography.heading_md}
      color: var(--text-placeholder);
    }
  }
  ${(props: Props) =>
    props.isHover &&
    css`
      &:hover {
        border: 0.5px solid transparent;
        .favicon-logo {
          filter: blur(1.5px);
        }
        .empty-logo {
          filter: blur(1.5px);
        }
        .logo {
          filter: blur(1.5px);
        }
        .logo-empty {
          filter: blur(1.5px);
        }
        .upload-block {
          display: flex;
          cursor: pointer;
        }
      }
    `}
  ${mobile_xl(css`
    .favicon-logo {
      width: 60px;
      height: 60px;
    }
    &.logo-img {
      padding: var(--space-10);
      .logo {
        height: 40px;
        border-radius: var(--border-radius-4);
      }
    }
  `)}
`;

const Content = styled.div`
  padding: var(--space-20);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
`;

const Overlay = styled.div<Props>`
  background-color: var(--background-thumb-overlay);
  border: 0.5px solid transparent;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ isEmptyLogo }) => (isEmptyLogo ? '53px' : '79px')};
  position: absolute;
  border-radius: var(--border-radius-6);
  display: none;
  justify-content: center;
  cursor: pointer;
  ${mobile_xl(css`
    height: 60px;
  `)}
`;
const TextBlock = styled.div<Props>`
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-5);
  p {
    ${Typography.body_sm_medium}
    margin: var(--space-0);
    color: var(--text-white);
    text-align: center;
  }
  .upload-icon {
    width: 18px;
    height: 18px;
    path {
      stroke: var(--text-white);
    }
  }
  ${(props: Props) =>
    props.display &&
    css`
      flex-direction: row;
      flex-wrap: wrap;
      margin: auto;
    `}
`;
const Mode = styled.div`
  color: var(--text-secondary);
  ${Typography.body_sm};
`;

export {
  Top,
  Desc,
  Card,
  Square,
  Logo,
  Content,
  Overlay,
  TextBlock,
  Mode,
  Section,
  ResponsiveBrandTitle,
  BrandTitleSection
};
